// Zamienia "31.55%", "12,3",  -5,  "  -5 % "  -> liczba (float)
export const toNumber = (v) => {
  if (v == null) return 0;
  if (typeof v === 'number' && Number.isFinite(v)) return v;

  const s = String(v)
    .trim()
    .replace(/\s+/g, '')     // usuń spacje wewnątrz
    .replace(',', '.');      // zamień przecinek na kropkę

  const noPercent = s.endsWith('%') ? s.slice(0, -1) : s;
  const n = parseFloat(noPercent);
  return Number.isFinite(n) ? n : 0;
};

// Formatuje z sufiksem %, domyślnie 2 miejsca
export const formatPercent = (v, decimals = 2) =>
  `${toNumber(v).toFixed(decimals)}%`;